import React, { useRef } from 'react';
import { useTooltip } from '../hooks/use-tooltip';

/**
 * Tooltip slouží pro zobrazení nápovědy při najetí myši, buď na předaný element, nebo, v případě absence elementu, na vykreslenou ikonu nápovědy.
 */

export const Tooltip = (props) => {
    const elementRef = useRef(null);

    const { show } = useTooltip(elementRef);

    return (
        <span className="react-tooltip-wrapper">
            <span ref={elementRef}>{props.children}</span>
            {show && props.text ? <div className="react-tooltip">{props.text}</div> : null}
        </span>
    );
};
